import React, { FC } from "react"
import styled from "styled-components"

const SvgOrbsPath = styled.svg`
  display: block;
  width: 100%;
  height: 100%;

  > path {
    fill: transparent;
    stroke: transparent;
  }
`

export const OrbsPath: FC = () => {
  return (
    <SvgOrbsPath
      height="557.59484"
      id="svg_orbs_path"
      viewBox="0 0 554.19876 557.59484"
      width="554.19876">
      <path
        d="m277.43532,271.57832c-.03928,1.91072-.03928,2.95143-.03928,2.95143,0,0,0-84.12179-22.68404-121.90988-37.39845-62.30001-37.31596-60.53553-37.31596-90.80087,0-33.13708,26.86292-60,60-60s60,26.86292,60,60c0,30.26527-.17815,26.44663-35.24884,90.80063-21.86412,40.12021-24.4144,104.48841-24.71188,118.95869"
        id="orbs_path_businessPolicies"
      />
      <path
        d="m282.5108,271.47055c-1.37886,1.32331-2.11475,2.0592-2.11475,2.0592,0,0,59.48309-59.48309,70.16326-102.24334,17.60806-70.49746,16.41871-69.19145,37.81955-90.59228,23.43146-23.43146,61.42136-23.43146,84.85281,0,23.43146,23.43146,23.43146,61.42136,0,84.85281-21.40077,21.40077-18.82656,18.57462-89.13044,39.28104-43.82954,12.90901-91.14806,56.62087-101.59043,66.64256"
        id="orbs_path_crm"
      />
      <path
        d="m284.34748,276.56903c-1.91072-.03928-2.95143-.03928-2.95143-.03928,0,0,84.12179,0,121.90988-22.68404,62.30001-37.39845,60.53553-37.31596,90.80087-37.31596,33.13708,0,60,26.86292,60,60s-26.86292,60-60,60c-30.26527,0-26.44663-.17815-90.80063-35.24884-40.12021-21.86412-104.48841-24.4144-118.95869-24.71188"
        id="orbs_path_ecommercePlatform"
      />
      <path
        d="m282.45525,281.6445c-1.32331-1.37886-2.0592-2.11475-2.0592-2.11475,0,0,59.48309,59.48309,102.24334,70.16326,70.49746,17.60806,69.19145,16.41871,90.59228,37.81955,23.43146,23.43146,23.43146,61.42136,0,84.85281-23.43146,23.43146-61.42136,23.43146-84.85281,0-21.40077-21.40077-18.57462-18.82656-39.28104-89.13044-12.90901-43.82954-56.62087-91.14806-66.64256-101.59043"
        id="orbs_path_helpdesk"
      />
      <path
        d="m277.35676,283.48118c.03928-1.91072.03928-2.95143.03928-2.95143,0,0,0,84.12179,22.68404,121.90988,37.39845,62.30001,37.31596,60.53553,37.31596,90.80087,0,33.13708-26.86292,60-60,60s-60-26.86292-60-60c0-30.26527.17815-26.44663,35.24884-90.80063,21.86412-40.12021,24.4144-104.48841,24.71188-118.95869"
        id="orbs_path_inventoryManagement"
      />
      <path
        d="m271.28129,281.58895c1.37886-1.32331,2.11475-2.0592,2.11475-2.0592,0,0-59.48309,59.48309-70.16326,102.24334-17.60806,70.49746-16.41871,69.19145-37.81955,90.59228-23.43146,23.43146-61.42136,23.43146-84.85281,0-23.43146-23.43146-23.43146-61.42136,0-84.85281,21.40077-21.40077,18.82656-18.57462,89.13044-39.28104,43.82954-12.90901,91.14806-56.62087,101.59043-66.64256"
        id="orbs_path_marketingAutomation"
      />
      <path
        d="m270.44461,276.49047c1.91072.03928,2.95143.03928,2.95143.03928,0,0-84.12179,0-121.90988,22.68404-62.30001,37.39845-60.53553,37.31596-90.80087,37.31596-33.13708,0-60-26.86292-60-60s26.86292-60,60-60c30.26527,0,26.44663.17815,90.80063,35.24884,40.12021,21.86412,104.48841,24.4144,118.95869,24.71188"
        id="orbs_path_orderManagement"
      />
      <path
        d="m271.33684,272.415c1.32331,1.37886,2.0592,2.11475,2.0592,2.11475,0,0-59.48309-59.48309-102.24334-70.16326-70.49746-17.60806-69.19145-16.41871-90.59228-37.81955-23.43146-23.43146-23.43146-61.42136,0-84.85281s61.42136-23.43146,84.85281,0c21.40077,21.40077,18.57462,18.82656,39.28104,89.13044,12.90901,43.82954,56.62087,91.14806,66.64256,101.59043"
        id="orbs_path_productCatalog"
      />
    </SvgOrbsPath>
  )
}
